import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const VirtualCFO = () => {
  const serviceData = {
    title: "Virtual CFO Services",
    heading: "Virtual CFO Services",
    image: subTopicImages["Strategic Financial Leadership"],
    intro: "CFO-Level Financial Leadership — Without a Full-Time CFO",
    description: [
      "Growing businesses and multinational subsidiaries often need strategic financial leadership, but may not yet require or be ready for a full-time Chief Financial Officer.",
      "Our Virtual CFO Services provide exactly that — experienced financial leadership on a flexible basis backed by senior Chartered Accountant expertise.",
      "We partner with Boards, promoters and management teams to support strategic financial planning, performance oversight, governance and reporting — helping you make better decisions with confidence.",
    ],
    services: [
      {
        title: "Strategic Financial Leadership",
        text: "We act as your outsourced CFO — delivering financial leadership, planning insight and strategic guidance without the cost of a full-time executive.",
        extraInfo:
          "Our Virtual CFO becomes a trusted part of your leadership team, helping you align financial strategy with business priorities and growth plans.",
      },
      {
        title: "Business Performance Review",
        text: "We help you understand how your business is performing — not just financially, but operationally.",
        list: [
          "review of profitability, cost drivers & margins",
          "business unit / segment performance analysis",
          "trend analysis and benchmarking",
          "identification of improvement opportunities",
        ],
        extraInfo:
          "Our insights help you focus on what drives performance and where improvements matter most.",
      },
      {
        title: "Capital Allocation & Cash-Flow Planning",
        text: "Effective financial planning and disciplined capital allocation are essential for growth and stability.",
        list: [
          "budgeting & forecasting",
          "capital deployment strategies",
          "working capital planning",
          "cash flow monitoring & projections",
          "scenario planning",
        ],
        extraInfo:
          "This gives you confidence that your resources are being used efficiently and strategically to support growth.",
      },
      {
        title: "Investor & Lender Reporting",
        text: "Raising capital or managing lender relationships requires professional, credible and timely reporting.",
        list: [
          "investor reporting & financial narratives",
          "covenant monitoring and reporting",
          "lender updates & compliance reporting",
          "financial communication frameworks",
        ],
        extraInfo:
          "This strengthens confidence with investors, lenders and strategic partners.",
      },
    ],
    benefitsIntro: "Why Organisations Use Our Virtual CFO Services",
    benefits: [
      "Professional financial leadership at a fraction of the cost",
      "Better financial clarity and decision support",
      "Structured planning, budgeting and forecasting",
      "Stronger governance and reporting discipline",
      "Confidence for investors, lenders and Boards",
      "Scalable support that grows with your business",
    ],
    research:
      "Who We Serve: Indian corporates across sectors, multinational subsidiaries operating in India, promoter-led and family-owned enterprises, growth-stage and high-potential companies, investor-backed businesses seeking financial leadership.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
      researchTitle="Who We Serve"
    />
  );
};

export default VirtualCFO;
